import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuToggleOption} from '@Components/contextual-menu/components/contextual-menu-toggle-option';
import type {RGBA} from '@Utils/color.util';
import {BaseItemMultiplyColorOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-multiply-color-option';
import {BaseItemMultiplyOpacityOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-multiply-opacity-option';

interface BaseItemMultiplyOptionProps {
  multiplyColor: RGBA;
  multiply: boolean;
  multiplyOpacity: number;

  onClickColorFill(): void;

  onToggleMultiply(): void;

  updateOpacity(value: number, undoable?: boolean): void;
}

export function BaseItemMultiplyOption({...props}: BaseItemMultiplyOptionProps): ReactElement {
  const onClickHandler = (): void => {
    props.onToggleMultiply();
  };

  const getMultiplyColorFillObject = (): ReactElement => {
    return (
      <BaseItemMultiplyColorOption
        multiplyColor={props.multiplyColor}
        onClickColorFill={(): void => {
          props.onClickColorFill();
        }}
      />
    );
  };

  const getSubOptions = (): ReactElement | null => {
    if (props.multiply) {
      return (
        <>
          {getMultiplyColorFillObject()}
          {getMultiplyOpacityFillObject()}
        </>
      );
    }

    return null;
  };

  const getMultiplyOpacityFillObject = (): ReactElement => {
    return (
      <BaseItemMultiplyOpacityOption
        multiplyOpacity={props.multiplyOpacity}
        updateOpacity={(value: number, undoable = true): void => {
          props.updateOpacity(value, undoable);
        }}
      />
    );
  };

  return (
    <ContextualMenuToggleOption id="item-multiply-option" label={window.i18next.t('pmwjs_multiply')} isChecked={props.multiply} onClick={onClickHandler}>
      {getSubOptions()}
    </ContextualMenuToggleOption>
  );
}
